import {
  Card,
  Input as InputField,
  Form,
  message,
  Pagination,
  Spin,
} from "antd";
import Dropdown from "../../../components/common/dropdown";
import Button from "../../../components/common/button";
import SupportTicket from "../../../components/common/supportTicket";

import { useEffect, useState } from "react";
import {
  deleteSupportTicket,
  getSupport,
  getSupportCategory,
  postSupport,
  uploadScreenshot,
} from "../../../api/support";
import { LoadingOutlined } from "@ant-design/icons";
import DeleteMemberModal from "../../../components/common/modalMember";
import SupportTicketImage from "../../../components/common/uploadSupportTicket";
import SupportModal from "./supportModal";
const TextArea = InputField.TextArea;
const Support = () => {
  const [supportList, setSupportList] = useState([]);
  const [data, setData] = useState();
  const [render, setRender] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPagesize] = useState(3);
  const [loading, setLoading] = useState(false);
  const [loader, setLoader] = useState(false);
  const [iloader, setIloader] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedId, setSelectedId] = useState();
  const [selectedImage, setSelectedImage] = useState(null);

  const [form] = Form.useForm();

  const fetchData = async () => {
    setLoading(true);
    const response = await getSupportCategory();
    setSupportList(response);
    const res = await getSupport(currentPage, pageSize);
    setData(res);
    setLoading(false);
  };
  const showModal = (id) => {
    setIsModalOpen(true);
    setSelectedId(id);
  };
  const detailModal = (id) => {
    setSelectedId(id);
    setShowDetailModal(true);
  };
  const hideModal = () => {
    setIsModalOpen(false);
    setShowDetailModal(false);
  };
  const YesClickHandler = async () => {
    setIsModalOpen(false);
    setShowDetailModal(false);
    const res = await deleteSupportTicket(selectedId);
    if (res) {
      message.success("Support Ticket Deleted!");
      setRender(!render);
    }
  };
  const onFinish = async (value) => {
    setLoader(true);
    const payload = {
      supportCategoryId: value?.category,
      issueTitle: value?.title,
      issueDescription: value?.desc,
    };
    if (selectedImage) {
      payload.image = selectedImage;
    }
    const res = await postSupport(payload);
    if (res) {
      setRender(!render);
      form.resetFields();
      setSelectedImage(null);
      message.success("Ticket Added SuccessFully");
    }
    setLoader(false);
  };
  const handleSizeChange = (current, size) => {
    setPagesize(size);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const handleChangeAndUploadScreenshot = async (e) => {
    setIloader(true);
    const file = e.target.files[0];

    if (file) {
      const formData = new FormData();
      formData.append("image", file);

      try {
        const response = await uploadScreenshot(formData);

        if (response?.url) {
          setSelectedImage(response?.url);
        }
      } catch (error) {
        console.error("Error uploading image:", error);
      } finally {
        setIloader(false);
      }
    } else {
      setIloader(false);
      setSelectedImage(null);
    }
  };
  const support = async () => {
    const res = await getSupport(currentPage, pageSize);
    setData(res);
  };
  const handleDeleteUploadFileIcon = () => {
    setSelectedImage(false);
  };
  useEffect(() => {
    fetchData();
    support();
  }, [currentPage, pageSize, render]);

  if (loading) {
    return (
      <div className="flex h-screen justify-center items-center">
        <Spin
          indicator={<LoadingOutlined />}
          className="flex justify-center"
          size="large"
        />
      </div>
    );
  }

  return (
    <Form form={form} onFinish={onFinish}>
      <div className="px-3">
        <div className="">
          <p className="text-lg font-medium tracking-wider">Write Your Issue</p>
        </div>
        <Card className="shadow-md">
          <div className=" m-3 grid grid-cols-1 lg:grid-cols-2 gap-2">
            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Category is required",
                },
              ]}
              name={"category"}
            >
              <Dropdown
                className="w-full"
                data={supportList}
                onChange={(e) => {}}
                placeholder={"Issue Category"}
              />
            </Form.Item>
            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Title is required",
                },
              ]}
              className="!h-full"
              name={"title"}
            >
              <InputField placeholder="Enter Title" className="h-5.4" />
            </Form.Item>
          </div>
          <div className=" px-3 ">
            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Description is required",
                },
              ]}
              name={"desc"}
            >
              <TextArea
                placeholder="Enter Description"
                className="w-full hover:border-primaryBlue"
                rows={4}
              />
            </Form.Item>
          </div>
          <Form.Item name="image">
            <div className="items-center grid grid-cols-1 md:grid-cols-2 justify-between  w-full">
              <div>
                <SupportTicketImage
                  text={"Change Avatar"}
                  isImageUpload={true}
                  screenshot={true}
                  selectedImage={selectedImage}
                  onChange={handleChangeAndUploadScreenshot}
                  iloader={iloader}
                  onClick={handleDeleteUploadFileIcon}
                />
              </div>
              <div className="flex justify-end">
                <Button
                  title="Submit"
                  htmlType="submit"
                  loading={loader}
                  className="w-20 justify-center  bg-primaryPurple m-2"
                />
              </div>
            </div>
          </Form.Item>
        </Card>
        {data?.totalItems > 0 ? (
          <div className="">
            <p className="text-lg font-medium tracking-wider">My Tickets</p>
            <div className="mb-3">
              {data?.items?.map((data, i) => (
                <div
                  className="mb-4 cursor-pointer"
                  onClick={() => {
                    detailModal(data);
                  }}
                  key={i}
                >
                  <SupportTicket
                    key={i}
                    data={data}
                    openModal={(id) => showModal(id)}
                  />
                </div>
              ))}
            </div>
            <div className="flex justify-center items-center pagination-container mb-2">
              <Pagination
                current={currentPage}
                total={data?.totalItems}
                pageSize={pageSize}
                onShowSizeChange={handleSizeChange}
                pageSizeOptions={[3, 10, 20, 30]}
                onChange={(e) => {
                  handlePageChange(e);
                }}
              />
            </div>
            {isModalOpen && (
              <DeleteMemberModal
                // id={selectedId}
                title="Delete Ticket"
                text="Are you sure you want to delete ticket?"
                onCancel={hideModal}
                onOk={YesClickHandler}
              />
            )}
            {showDetailModal && !isModalOpen && (
              <SupportModal
                title="Ticket Details"
                issueTitle={selectedId?.issueTitle}
                issueDescription={selectedId?.issueDescription}
                onCancel={hideModal}
              />
            )}
          </div>
        ) : (
          <div></div>
        )}
      </div>
    </Form>
  );
};
export default Support;
